// extracted by mini-css-extract-plugin
module.exports = {"erasor":"ErasorIcon_erasor__-10VM","svg":"ErasorIcon_svg__V4Mqi"};